export type VForm = Vue & { validate: () => boolean };

export type ActionMethod<T, V> = (...args: T[]) => Promise<V>;

export function isNumber(ele: unknown): boolean {
  return typeof ele === 'number';
}
